module.exports = __webpack_public_path__ + "img/click_1.b896c2ed.svg";